import { applicationConfig } from "@/config";
import type { AuthResponse, ErrorApiResponse } from "../types";

export const api = {
    signin: async (username: string, password: string): Promise<AuthResponse> => {
        const endpoint = `${applicationConfig.apiUri}/api/auth/signin`;
        try {
            const params = new URLSearchParams();
            params.append("username", username);
            params.append("password", password);
            const response = await fetch(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: params,
            });

            if (!response.ok) {
                const authFailedResponse: ErrorApiResponse = await response.json();
                throw new Error(authFailedResponse.detail || "An error occurred during login.");
            }

            const data: AuthResponse = await response.json();
            return data;
        } catch (error) {
            // Handle network errors or errors from the fetch call itself
            console.error("Login API error:", error);
            if (error instanceof Error) {
                throw error;
            }
            throw new Error("An unknown error occurred.");
        }
    },

    signout: async (token: string): Promise<ErrorApiResponse | undefined> => {
        const endpoint = `${applicationConfig.apiUri}/api/auth/logout`;
        try {
            const response = await fetch(endpoint, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                return { detail: "Error during logout" };
            }
        } catch (error) {
            // Handle network errors or errors from the fetch call itself
            console.error("Logout API error:", error);
            if (error instanceof Error) {
                throw error;
            }
            throw new Error("An unknown error occurred.");
        }
    },
};
